<template>
  <el-dialog :visible.sync="Visible" :modal="false" @close="close" center class="ac-dialog" width="900px">
    <el-table :data="itemData" element-loading-text="拼命加载中" border height="550" highlight-current-row
      style="width: 100%">
      <el-table-column align="center" label="章节ID" width="80">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column align="center" label="标题" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column align="center" label="点击预览">
        <template slot-scope="scope">
          <i v-if="scope.row.is_audio === 'y'" class="el-icon-video-play views" title="点击预览"
            @click="checkMedia(scope.row.content, scope.row)"></i>
          <div v-else>暂无</div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="是否有声" width="90">
        <template slot-scope="scope">
          <el-button :type="scope.row.is_audio ? 'success' : 'danger'" plain size="mini">{{ scope.row.status ? "是" : "否"
            }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button size="small" type="success" @click="lookMore(scope.row.content)">查看详细内容</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="showMore" :modal="false" top class="more-img-dialog" width="900px">
      <div class="more-img">
        <div v-for="(item, index) in contentData" :key="index" :style="{ height: 'auto', width: '100px' }">
          <decrypt-img :noNeedDoamin="true" :src="item.f"></decrypt-img>
        </div>
      </div>
    </el-dialog>
  </el-dialog>

</template>
<script>


export default {
  props: ['itemData'],
  components: {
    
  },
  data() {
    return {
      Visible: true,
      showMore: false,
      contentData: [],

    };
  },
  mounted() {

  },
  methods: {
    changeImagesUrl(data) {
      this.form.chapter = data
    },
    setIsUploadIng(status) {
      this.isUploadIng = status
    },

    // 关闭编辑
    close() {
      this.$emit('close', false)
    },
    // 视频查看
    checkMedia(url, data) {
      this.$refs.showvideo.open(url, data, data.id)
    },
    lookMore(data) {
      this.showMore = true
      this.contentData = data
    }
  },
};
</script>
<style lang='scss' scoped>
.ac-dialog {
  overflow: hidden;

  ::v-deep {
    .el-dialog {
      margin-top: 10px !important;
    }
  }
}

.more-img-dialog {
  .more-img {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
